<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: SkeletonPersonHeader                                  |
| Section: components/Skeletons                                    |
| Purpose: Loading skeleton placeholder for the person header.     |
+------------------------------------------------------------------+
-->
<template>
  <header class="wrapper">
    <!-- Photo placeholder -->
    <div class="skeleton person_photo"></div>

    <!-- Name + Citation -->
    <div class="header_box">
      <div class="skeleton skeleton-title"></div>
    </div>

    <!-- Nickname -->
    <div class="skeleton skeleton-subtitle"></div>

    <!-- Loading Spinner -->
    <div class="loader">
      <svg class="spinner" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
      </svg>
    </div>

    <!-- StoryCard -->
    <!-- <div class="skeleton skeleton-storycard"></div> -->

    <!-- Simulated button -->
    <div class="skeleton skeleton-btn"></div>
  </header>
</template>

<style scoped>
header {
  position: relative;
  margin-top: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  min-height: 100vh;
}

.person_photo {
  width: 130px;
  height: 130px;
  border-radius: var(--border-radius-pill);
  margin-bottom: 36px;
  box-shadow: var(--shadow-photo);
}

.header_box {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 8px;
}

.skeleton-title {
  width: 720px;
  height: 72px;
}

.skeleton-subtitle {
  width: 250px;
  height: 24px;
  margin-top: 8px;
}

.loader {
  margin-top: 96px;
}

.skeleton-storycard {
  margin-top: 144px;
  width: 100%;
  height: 100%;
  min-height: 100vw;
  border-radius: var(--border-radius-xl);
}

.skeleton-btn {
  position: absolute;
  left: 20px;
  top: 0;
  width: 150px;
  height: 52px;
  border-radius: 999px;
}
</style>